"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipStationTrackingStatusDescription = exports.ShipStationTrackingStatusCode = exports.ShipStationTrackingCarrier = void 0;
var ShipStationTrackingCarrier;
(function (ShipStationTrackingCarrier) {
    ShipStationTrackingCarrier["USPS"] = "USPS";
    ShipStationTrackingCarrier["FEDEX"] = "fedex";
})(ShipStationTrackingCarrier || (exports.ShipStationTrackingCarrier = ShipStationTrackingCarrier = {}));
var ShipStationTrackingStatusCode;
(function (ShipStationTrackingStatusCode) {
    ShipStationTrackingStatusCode["ACCEPTED"] = "AC";
    ShipStationTrackingStatusCode["IN_TRANSIT"] = "IT";
    ShipStationTrackingStatusCode["DELIVERED"] = "DE";
    ShipStationTrackingStatusCode["EXCEPTION"] = "EX";
    ShipStationTrackingStatusCode["UNKNOWN"] = "UN";
    ShipStationTrackingStatusCode["DELIVERY_ATTEMPT"] = "AT";
    ShipStationTrackingStatusCode["NOT_YET_IN_SYSTEM"] = "NY";
    ShipStationTrackingStatusCode["DELIVERED_TO_COLLECTION_LOCATION"] = "SP";
})(ShipStationTrackingStatusCode || (exports.ShipStationTrackingStatusCode = ShipStationTrackingStatusCode = {}));
var ShipStationTrackingStatusDescription;
(function (ShipStationTrackingStatusDescription) {
    ShipStationTrackingStatusDescription["ACCEPTED"] = "Accepted";
    ShipStationTrackingStatusDescription["IN_TRANSIT"] = "In Transit";
    ShipStationTrackingStatusDescription["DELIVERED"] = "Delivered";
    ShipStationTrackingStatusDescription["EXCEPTION"] = "Exception";
    ShipStationTrackingStatusDescription["UNKNOWN"] = "Unknown";
    ShipStationTrackingStatusDescription["DELIVERY_ATTEMPT"] = "Delivery Attempt";
    ShipStationTrackingStatusDescription["NOT_YET_IN_SYSTEM"] = "Not Yet in System";
    ShipStationTrackingStatusDescription["DELIVERED_TO_COLLECTION_LOCATION"] = "Delivered to the Collection Location";
})(ShipStationTrackingStatusDescription || (exports.ShipStationTrackingStatusDescription = ShipStationTrackingStatusDescription = {}));
